<template>
   <div class="customAggregateColumnTag-list">
      <el-form class="company-form">
          <el-form-item label="已设置字段：">
            <draggable :list="selectTags" :options="appContentOpts" class="subform-field-list" @change="handleDragTag()">
              <el-tag
                  style="cursor:pointer;"
                  :key="tag.id"
                  v-for="tag in selectTags"
                  closable
                  effect="dark"
                  type="warning"
                  :disable-transitions="false"
                  @click.stop="setTag(tag)"
                  @close="handleClose(tag)">
                      {{tag.label}}
              </el-tag>
            </draggable>
              <el-input 
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag"  size="small" @click="showInput">+ 新增聚合字段</el-button>
          </el-form-item>
          <!-- <el-form-item label="标签及档案模板" prop="companyName">
              <TreeSelect
                  v-if="isShowTagsTree"
                  ref="treeSelect" 
                  :sourceOptions="sourceOptions" 
                  :disableBranchNodes="false"
                  @treeSelectChoose="treeSelectChoose"
                  :multiple="true"  
                  :flat="true"
              /> 
          </el-form-item> -->
           <!-- <el-form-item label="我定义的标签" prop="companyName">
              <el-tag
                  :key="tag.id"
                  v-for="tag in userTags"
                  closable
                  type="info"
                  :disable-transitions="false"
                  @close="handleDelete(tag)">
                  {{tag.label}}
              </el-tag>
          </el-form-item> -->
      </el-form>
</div>

</template>

<script>
import TreeSelect from '@/components/TreeSelect';
import { } from '@/data-model';
import Draggable from 'vuedraggable';
export default {
    // register the component
    components: {
        TreeSelect: TreeSelect,
        Draggable
    },
    data () {
        return {
            appContentOpts: {
                // handle: '.form-item-label',
                group: {
                    name: 'appContent',
                    put: [ 'formToolbar' ]
                },
                sort: true
            },
            selectMap: new Map(),
            // selectTags: [
            //   // {"id":"1","label":"过程文件"},
            // ],
            isShowTagsTree: false,
            userTags: [],
            selectedTree: [],
            sourceOptions: [
            ],
            inputVisible: false,
            inputValue: ''
        };
    },
    props: {
        selectTags: { // 已选择的标签
            type: Array
        },
        formId: {
            type: String,
            default: ''
        }
    },
    created () {
        // this.initData();
        // console.log(this.selectTags);
    },
    methods: {
        async initData () {
            this.selectMap = new Map();
            this.selectedTree = [];
            // await this.getTagsList();
            this.selectTags.forEach(item => {
                this.selectMap.set(item.id, item);
                // this.selectedTree.push(item.id);
            });
            // setTimeout(() => {
            //     this.$refs.treeSelect.initParam(this.selectedTree);
            // }, 0);
        },
        async getTagsList () {
            // console.log(tags);
            this.isShowTagsTree = true;
            this.sourceOptions = [];
            this.userTags = [];
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            let currentUserInfo = JSON.parse(currentUserStr);
            // console.log(currentUserInfo);
            this.sourceOptions.forEach(item => { // 递归查找子节点
                if (item.tagFlg === 0) {
                    if (currentUserInfo.userId === item.createdBy && !item.root) {
                        this.userTags.push(item);
                    }
                    if (item.children) {
                        this.findChildrenTags(item.children, currentUserInfo.userId);
                    }
                }
            });
        },
        findChildrenTags (arr, userId) {
            arr.forEach((v, i) => {
            // console.log(v.createdBy);
                if (userId === v.createdBy) {
                    this.userTags.push(v);
                }
                if (v.children) {
                    this.findChildrenTags(v.children, userId);
                }
            });
        },
        treeSelectChoose (selected) { // 选择好数据源后
        // console.log(selected);
            if (selected && selected.length > 0 && selected[0] === undefined) {
                return;
            }
            selected.forEach(item => {
                if (!this.selectMap.has(item.id)) {
                    this.selectTags.push(item);
                    this.selectMap.set(item.id, item);
                }
            });
            for (var i = 0, len = this.selectTags.length; i < len; i++) {
                let flg = false;
                if (!this.selectTags[i] || this.selectTags[i] === undefined) {
                    continue;
                }
                for (var j = 0, len2 = selected.length; j < len2; j++) {
                    if (!selected[j] || selected[j] === undefined) {
                        continue;
                    }
                    if ((this.selectTags[i].id + '') === (selected[j].id + '')) {
                        flg = true;
                    }
                }
                if (!flg) {
                    let removeTag = this.selectTags.splice(i, 1);
                    this.selectMap.delete(removeTag[0].id);
                }
            }
        // console.log(this.selectTags);
        },
        setTag (tag) { // 配置聚合字段的公式
            // console.log(tag);
            this.$emit('synConfigFileds', tag);
        },
        async handleClose (tag) {
            this.$confirm('您确定要删除聚合字段[ ' + tag.label + ' ]吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                let removeTag = this.selectTags.splice(this.selectTags.indexOf(tag), 1);
                if (removeTag && removeTag[0]) {
                    this.selectMap.delete(removeTag[0].id);
                    this.$emit('synDelFileds', removeTag[0]);
                // if(!removeTag[0].isNew){//非新增的标签时刷新标签树
                // this.selectedTree = [];
                // this.selectTags.forEach(item => {
                //     if (!item.isNew) {
                //         this.selectedTree.push(item.id);
                //     }
                // });
                // setTimeout(() => {
                //     this.$refs.treeSelect.initParam(this.selectedTree);
                // }, 0);
                // }
                }
            }).catch(() => {});
        },
        showInput () {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        async handleInputConfirm () {
            let inputValue = this.inputValue;
            if (inputValue.trim() === '') {
                this.inputVisible = false;
                return;
            }
            if (inputValue) {
                let addField = {id: this.generateUUID(), label: inputValue, name: inputValue, isNew: true, tagFlg: 0};
                addField.prop = addField.id;
                this.$emit('synAddFileds', addField);
                if (!this.formId) {
                    this.selectTags.push(addField);
                }
            }
            this.inputVisible = false;
            this.inputValue = '';
            // await this.getTagsList();
            this.initData();
        },
        generateUUID () {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === 'function') {
                d += window.performance.now(); // use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid.replace(RegExp('-', 'g'), '');
        },
        async handleDelete (tag) {
            // let realId = tag.id.substring(tag.id.indexOf('-') + 1);
            // await deleteTag(realId);
            this.selectMap.delete(tag.id);
            this.selectedTree = [];
            for (var i = 0, len2 = this.selectTags.length; i < len2; i++) {
                if (this.selectTags[i]) {
                    if ((this.selectTags[i].id + '') === (tag.id + '')) {
                        this.selectTags.splice(i, 1);
                    }
                    // else{
                    //   this.selectedTree.push(this.selectTags[i].id);
                    // }
                }
            }
            // this.selectTags.forEach(item => {
            //     this.selectedTree.push(item.id + '');
            // });
            // setTimeout(() => {
            //     this.$refs.treeSelect.initParam(this.selectedTree);
            // }, 0);
            // this.getTagsList();
        // // this.initData();
        },
        handleDragTag () {
            // console.log(this.selectTags);
        }
    }
};
</script>

<style>
.customAggregateColumnTag-list {
    /* width:600px; */
    overflow: auto;
    .subform-field-list{
      display: flex;
      flex-wrap: wrap;
    }
}
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
 
</style>


// WEBPACK FOOTER //
// src/components/CustomAggregateTable/CustomAggregateColumnTag.vue